import React, { useMemo, useState, useRef } from 'react';
import classNames from 'classnames';
import moment from 'moment-timezone';
import { IconLoader } from '../../../common/IconLoader';
import Dropdown from '../Dropdown/Dropdown';
import DualCalendar from '../CalendarFilter/CalendarFilter';
import { IconAndText } from '../SvgAF/SvgAF';
import styles from './TimeSelect.module.css';
import { defaultOptions, getTimeRange } from './utils';
import { useDropdown } from './hooks';

function TimeSelect({ value, options = defaultOptions, onChange, direction = 'right', className, hideArrow }) {
  const dropdownRef = useRef(null);
  const [mode, setMode] = useState(null);
  const range = useMemo(() => getTimeRange(value), [value]);
  const { title, data, selectItem } = useDropdown({ value, options, onChange });

  const openCalendar = () => {
    setMode('CALENDAR');
  };
  const closeCalendar = () => {
    setMode(null);
  };

  const handleClose = () => {
    closeCalendar();
    dropdownRef.current?.toggleMenu();
  };

  const handleSubmit = (from, to) => {
    const localTimeZone = moment.tz.guess();
    const fromMoment = moment.utc(from).tz(localTimeZone).startOf('day');
    const toMoment = moment.utc(to).tz(localTimeZone).endOf('day');

    onChange({ from: fromMoment.toISOString(), to: toMoment.toISOString() });
    handleClose();
  };

  return (
    <div className={classNames(styles.root, className)}>
      <Dropdown
        ref={dropdownRef}
        data-testid="time-select"
        className={classNames(styles.dropdown, {
          [styles.left]: direction === 'left',
          [styles.right]: direction === 'right'
        })}
        keyRef={true}
        selectItem={selectItem}
        title={title}
        data={data}
        hideArrow={hideArrow}
        customMode={mode}
        setCustomMode={setMode}
        customSection={
          <div className="customDDSection">
            {mode === 'CALENDAR' ? (
              <div className="customCalendarSection">
                <DualCalendar startDay={range[0]} endDay={range[1]} handleSubmit={handleSubmit} close={handleClose} />
              </div>
            ) : (
              <div className="customDropdownList">
                <div onClick={openCalendar} className="customRangeSelection">
                  <IconAndText
                    img={IconLoader.icon_customdate}
                    hoverImg={IconLoader.icon_customdate}
                    text={'Select custom DATE range'}
                  />
                </div>
              </div>
            )}
          </div>
        }
        customButtonContent={
          mode === 'CALENDAR' ? (
            <div className="dropdownButtonCustomTimeButton">
              <img src={IconLoader.icon_customdate} alt="" />
              Select custom range
            </div>
          ) : !value.span ? (
            <div className="dropdownButtonCustomTimeButton">
              <img src={IconLoader.icon_customdate} alt="" />
              <span>{moment(value.from).format('MMM D, YYYY')}</span>
              <span className="dropdownButtonCustomTimeDivider">-</span>
              <span>{moment(value.to).format('MMM D, YYYY')}</span>
            </div>
          ) : null
        }
        customClose={closeCalendar}
        overflowEllipsis={true}
      />
    </div>
  );
}

export default TimeSelect;
